// Cookie-consent + Google Analytics loader.
//
// Google Analytics is loaded ONLY after the user explicitly grants consent
// (GDPR opt-in). Until then, no GA script runs and no analytics cookies are set.

export const GA_MEASUREMENT_ID = 'G-MQRZE8ZTT6';
export const CONSENT_KEY = 'tc-cookie-consent'; // 'granted' | 'denied'
export const COOKIE_SETTINGS_EVENT = 'tc-open-cookie-settings';

export const getConsent = () => {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
};

export const setConsent = (value) => {
  try { localStorage.setItem(CONSENT_KEY, value); } catch { /* private mode / quota */ }
};

let gaLoaded = false;

// Inject the GA script and initialize it. Idempotent — safe to call more than once.
export const loadAnalytics = () => {
  if (gaLoaded || typeof window === 'undefined' || !GA_MEASUREMENT_ID) return;
  gaLoaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
};

// Best-effort removal of GA cookies when consent is declined or withdrawn.
export const clearAnalyticsCookies = () => {
  try {
    const host = window.location.hostname;
    const parent = '.' + host.split('.').slice(-2).join('.');
    const domains = ['', `; domain=${host}`, `; domain=.${host}`, `; domain=${parent}`];
    document.cookie.split(';').forEach((c) => {
      const name = c.split('=')[0].trim();
      if (/^_ga/.test(name) || name === '_gid') {
        domains.forEach((d) => {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d}`;
        });
      }
    });
  } catch { /* noop */ }
};

// Let other components (e.g. a footer "Cookie preferences" link) re-open the
// consent banner so users can change or withdraw their choice at any time.
export const openCookieSettings = () => {
  try { window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT)); } catch { /* noop */ }
};
